export default __webpack_public_path__ + "static/media/Sample.e1f5bbba.csv";